import { createReducer, on } from '@ngrx/store';
import { selectEntity } from './global-select.actions';

export interface State {
  [entityName: string]: number | string;
}

export const initialState: State = {};

export const reducer = createReducer(
  initialState,
  on(selectEntity, (state, action) => ({ ...state, [action.entityName]: action.id })),
);
